<div class="card bank-account-card p-4">
  <div class="d-flex justify-content-between align-items-baseline">
    <app-section-header title="Conta Bancária" />

    <div class="d-flex gap-2">
      <button
        type="button"
        class="btn btn-outline-light shadow-none border-0 p-2 mr-2"
        placement="top"
        [disabled]="hasPendingChanges || deleting"
        (click)="editBankAccountClick.emit(account_info)">
        <i class="pi pi-pencil"></i>
      </button>
      <button
        type="button"
        class="btn btn-outline-light shadow-none border-0 p-2"
        placement="top"
        [disabled]="deleting"
        (click)="deleteBankAccountClick.emit()">
        <i class="pi" [class.pi-trash]="!deleting" [class.pi-spinner]="deleting" [class.pi-spin]="deleting"></i>
      </button>
    </div>
  </div>

  @if (hasPendingChanges) {
    <div
      class="pending-changes-banner"
      role="button"
      tabindex="0"
      (click)="viewPendingChangesClick.emit()"
      (keyup.enter)="viewPendingChangesClick.emit()">
      <i class="pi pi-info-circle"></i>
      <span>Existem alterações pendentes de aprovação. Clique para visualizar.</span>
    </div>
  }

  <div>
    @if (account_info) {
      <p>Banco: {{ account_info.bank_name }}</p>
      <p>Agência: {{ account_info.agency }}</p>
      <p>Conta: {{ account_info.account_number }} - {{ account_info.account_digit }}</p>
      <p>Nome: {{ account_info.account_holder }}</p>
      <p>Chave Pix: {{ account_info.pix_key }}</p>
    } @else {
      <p>Você ainda não possui uma conta bancária vinculada.</p>
      <button type="button" class="btn btn-outline-light m-auto d-block" (click)="editBankAccountClick.emit()">
        Vincular dados bancários
      </button>
    }
  </div>
</div>
